export class UserContext {
	idUtente: number;
    nomeUtente: string;
	tipoUtente: number;
	pwdChangeRequired: boolean;
	securityToken: string;
	flCarte: boolean;
	flTokenDisplay: boolean;
	flTokenYukido: boolean;
	flTokenDisplayPrivati: boolean;
	flTokenYukidoPrivati: boolean;
  }

export enum TipoUtente {
	Amministratore = 1,
	Produttore = 2,
	Smistatore = 3,
	Richiedente = 4
}
  


// WEBPACK FOOTER //
// ./src/app/_models/user-context.ts